<script>
	import PageBanner from  "$lib/sections/PageBanner.svelte";
	import Testimonials from  "$lib/sections/Testimonials.svelte";
	import Features from  "$lib/sections/Features.svelte";

	export let data;

	let lang;
	$: lang = data.lang;

	let area;
	$: area = data.area;

	const col = "testimonials";
</script>

<PageBanner {data} {lang} {area} {col} settingId={"PageBanner"} />

<Testimonials {data} {lang} {area} {col} settingId={"Testimonials"} />

<Features {data} {lang} {area} {col} settingId={"Features"} />
